import api from 'boot/api'
import apollo from 'boot/apollo'
import bettingApi from 'boot/betting-api'
import errors from 'boot/errors'
import firebase from 'boot/firebase'
import globalComponents from 'boot/global-components'
import gtmSupport from 'boot/gtm-support'
import i18n from 'boot/i18n'
import initCore from 'boot/init-core'
import localeProfile from 'boot/locale-profile'
import plugins from 'boot/plugins'
import preparation from 'boot/preparation'
import sw from 'boot/sw'
import unhead from 'boot/unhead'

const baseBootChain = [
  {
    name: 'apollo',
    setup: apollo,
  },
  {
    name: 'initCore',
    setup: initCore,
  },
  {
    name: 'errors',
    setup: errors,
  },
  {
    name: 'preparation',
    setup: preparation,
  },
  {
    name: 'firebase',
    setup: firebase,
  },
  {
    name: 'sw',
    setup: sw,
  },
  {
    name: 'plugins',
    setup: plugins,
  },
  {
    name: 'unhead',
    setup: unhead,
  },
  {
    name: 'api',
    setup: api,
  },
  {
    name: 'i18n',
    setup: i18n,
  },
  {
    name: 'localeProfile',
    setup: localeProfile,
  },
  {
    name: 'gtmSupport',
    setup: gtmSupport,
  },
  {
    name: 'globalComponents',
    setup: globalComponents,
  },
]

export async function runAppBootChain(ctx) {
  const chain = [...baseBootChain]

  if (process.env.OWN_SPORT) {
    chain.push({
      name: 'bettingApi',
      setup: bettingApi,
    })
  }

  let result = []

  for (const { setup } of chain) {
    const data = await setup(ctx)

    if (data) {
      result.push(data)
    }
  }

  return result.at(-1)
}
